<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      domains: ['gmail.com', 'googlemail.com', 'yahoo.com', 'hotmail.com', 'aol.com', 'msn.com', 'comcast.net', 'live.com', 'live.co', 'icloud.com'],
    }
  },
  computed: {
    email: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    querySearch(queryString, cb) {
      if (queryString === '') {
        cb([])
        return
      }
      const account = queryString.split('@')[0].toLowerCase()
      const hasDomain = queryString.match(/@.+/) !== null
      let domains = this.domains
      if (hasDomain) {
        const splitMail = queryString.match(/@.+/)[0].split('@')
        const hasDuplicateMouse = splitMail.length > 2
        if (hasDuplicateMouse) {
          cb([])
          return
        }

        const partialDomain = splitMail[1]
        // 相等於 domain 不顯示
        domains = this.domains.filter((domain) => domain.indexOf(partialDomain) > -1 && domain !== partialDomain)
      }

      const result = domains.map((domain) => ({ value: `${account}@${domain}` }))
      cb(result)
    },
    emitValue(value) {
      this.$emit('changeCompanyEmail', value)
    },
  },
}
</script>
<template>
  <el-autocomplete
    v-model="email"
    :class="className"
    :fetch-suggestions="querySearch"
    :placeholder="placeholder"
    :trigger-on-focus="false"
    :clearable="clearable"
    :disabled="disabled"
    @input="emitValue"
  ></el-autocomplete>
</template>
